export default __webpack_public_path__ + "static/media/1258.9e2b9855.png";